export default __webpack_public_path__ + "static/media/NoImage.1c19d973.png";